import React from 'react';

import Initialiser from '../../utils/initialise';
import Shutdown from '../../utils/shutdown';

export interface IProps {}

const BzErrorsInitialiser = React.memo(() => {
  React.useEffect(() => {
    Initialiser();

    return Shutdown;
  }, []);

  return null;
});

BzErrorsInitialiser.displayName = 'BzErrorsInitialiser';

export default BzErrorsInitialiser;
